var _Path, _Path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgPrescriptionRefill = function SvgPrescriptionRefill(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 56 56"
  }, props), /*#__PURE__*/React.createElement(Path, {
    fill: props.fillLine,
    fillRule: "evenodd",
    d: "M28.735 9.276 9.276 28.735c-4.717 4.717-4.717 12.366 0 17.083 4.717 4.718 12.366 4.718 17.084 0L45.818 26.36c4.718-4.718 4.718-12.367 0-17.084-4.717-4.718-12.366-4.718-17.083 0ZM7.508 26.966c-5.694 5.695-5.694 14.926 0 20.62 5.694 5.694 14.925 5.694 20.62 0l19.458-19.459c5.694-5.694 5.694-14.925 0-20.619-5.694-5.694-14.925-5.694-20.62 0L7.509 26.967Z",
    clipRule: "evenodd"
  }), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#000",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    d: "M28.735 9.276 9.276 28.735c-4.717 4.717-4.717 12.366 0 17.083 4.717 4.718 12.366 4.718 17.084 0L45.818 26.36c4.718-4.718 4.718-12.367 0-17.084-4.717-4.718-12.366-4.718-17.083 0ZM7.508 26.966c-5.694 5.695-5.694 14.926 0 20.62 5.694 5.694 14.925 5.694 20.62 0l19.458-19.459c5.694-5.694 5.694-14.925 0-20.619-5.694-5.694-14.925-5.694-20.62 0L7.509 26.967Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement(Path, {
    fill: props.accentFillLine,
    fillRule: "evenodd",
    d: "m19.335 24.414-6.87 6.87A8 8 0 0 0 23.778 42.6l6.87-6.87a2.267 2.267 0 0 0 0-3.207l-8.107-8.108a2.267 2.267 0 0 0-3.207 0Zm-8.639 5.103c-4.1 4.1-4.1 10.75 0 14.85 4.101 4.1 10.75 4.1 14.85 0l6.872-6.871a4.767 4.767 0 0 0 0-6.742l-8.108-8.108a4.767 4.767 0 0 0-6.742 0l-6.872 6.87Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: props.fillLine,
    fillRule: "evenodd",
    d: "M41.844 11.29a6.945 6.945 0 0 0-8.942.258l-3.529 3.148a1.25 1.25 0 1 1-1.664-1.865l3.528-3.149a9.445 9.445 0 0 1 12.161-.35 1.25 1.25 0 1 1-1.554 1.958Z",
    clipRule: "evenodd"
  }), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    fill: "#000",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    d: "M41.844 11.29a6.945 6.945 0 0 0-8.942.258l-3.529 3.148a1.25 1.25 0 1 1-1.664-1.865l3.528-3.149a9.445 9.445 0 0 1 12.161-.35 1.25 1.25 0 1 1-1.554 1.958Z",
    clipRule: "evenodd"
  })));
};
export default SvgPrescriptionRefill;